module.exports = __webpack_public_path__ + "img/bunkering-log.f4ad463d.svg";